<div mat-dialog-title class="mat-dialog-header">
    <h2 class="dialog-title">Characteristic Images</h2>
</div>

<div class="pv-move-host">

<div mat-dialog-content [ngSwitch]="status$ | async">

    <!-- LOADING -->
    <div class="info-wrapper" *ngSwitchCase="Status.LOADING">
        <mat-spinner></mat-spinner>
    </div>

    <!-- UNINITIALIZED (pre-dispatch render tick) -->
    <div class="info-wrapper" *ngSwitchCase="Status.UNINITIALIZED">
        <mat-spinner></mat-spinner>
    </div>

    <!-- OK -->
    <ng-container *ngSwitchCase="Status.OK">

        <div class="save-error-note text-warn" *ngIf="isSaveError(saveStatus$ | async)">
            Some images could not be deleted. Please try again.
        </div>

        <div class="characteristic-image-add-container">

            <div class="image-file-dropbox"
                 (drop)="onDrop($event)"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 [class.dragging]="isDragging"
                 [class.disabled]="!selectedChar">

                <div class="image-drop-request">
                    <p>Drag and drop image files here to upload.</p>
                    <label for="char_image_file_input">Browse Files</label>
                    <input id="char_image_file_input" (change)="fileInputChanged($event)" type="file" [disabled]="!selectedChar">
                    <div class="image-error text-warn" *ngFor="let error of validationErrors">{{ error }}</div>
                </div>

                <div class="image-drop-results" *ngIf="uploads$ | async as uploads">
                    <div class="image-upload" *ngFor="let upload of uploads; trackBy: trackUpload">
                        <div [ngSwitch]="upload.status">
                            {{ upload.loaded | formatBytes }}/{{ upload.total | formatBytes }}
                            <span *ngSwitchCase="'LOADING'">Uploading...</span>
                            <span *ngSwitchCase="'COMPLETE'" class="text-primary">Done</span>
                            <span *ngSwitchDefault class="text-warn">{{ upload.status | descStatusTitle }}</span>
                        </div>
                        <mat-progress-bar mode="determinate" [value]="upload.loaded / upload.total * 100"></mat-progress-bar>
                    </div>
                </div>

            </div>

            <mat-form-field appearance="standard" class="char-picker-field">
                <mat-label>Add image for characteristic</mat-label>
                <mat-select [formControl]="charControl">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="charFilterCtrl"
                                               placeholderLabel="Find Characteristic..."
                                               noEntriesFoundLabel="No matching entry found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let char of filteredChars | async; trackBy: trackChar" [value]="char.id">
                        {{ char.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="analysis-gap-note" *ngIf="selectedChar?.imageModelId">
                This characteristic has an analysis model, but images added from the web are saved without analysis — on-device analysis is mobile-only.
            </div>

        </div>

        <div class="info-wrapper" *ngIf="groups.length === 0">
            <span>No images yet for this evaluation.</span>
        </div>

        <ng-container *ngFor="let group of groups; trackBy: trackGroup">

            <h2 class="group-title mat-title">{{ group.char.label }}</h2>

            <div class="characteristic-image-gallery-container">
                <div class="characteristic-image-card"
                     *ngFor="let image of group.images; let i = index; trackBy: trackImage"
                     [class.image-deleted]="pendingDeleteKeys.includes(image.key)"
                     [attr.aria-label]="group.char.label + ' image ' + (i + 1) + ' of ' + group.images.length">
                    <div class="characteristic-image-card-file-wrapper">
                        <pv-image-ref class="characteristic-image-card-file"
                                      (click)="openViewer(group, i)"
                                      [fileRef]="image.fileRef"
                                      transformId="thumb_300">
                        </pv-image-ref>
                    </div>

                    <div class="characteristic-image-card-fields" *ngIf="dateGroupFor(image) as dateGroup" [formGroup]="dateGroup">
                        <mat-form-field appearance="standard" class="date-field">
                            <mat-label>Observed Date</mat-label>
                            <input type="text" matInput formControlName="takenAt"
                                   [matDatepicker]="takenDatepicker">
                            <mat-datepicker-toggle matSuffix [for]="takenDatepicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker #takenDatepicker></mat-datepicker>
                            <mat-hint>{{ dateGroup.get('takenAt').value | amTimeAgo }}</mat-hint>
                        </mat-form-field>

                        <button type="button"
                                class="characteristic-image-delete-button"
                                mat-icon-button
                                (click)="toggleDelete($event, image)"
                                [matTooltip]="pendingDeleteKeys.includes(image.key) ? 'Restore Image' : 'Delete Image'">
                            <mat-icon>
                                {{ pendingDeleteKeys.includes(image.key) ? 'restore_from_trash' : 'delete' }}
                            </mat-icon>
                        </button>
                    </div>
                </div>
            </div>

        </ng-container>

    </ng-container>

    <!-- DEFAULT / ERROR -->
    <div class="info-wrapper" *ngSwitchDefault>
        <mat-icon color="warn">error</mat-icon>
        <span>An error occurred while loading the characteristic images.</span>
    </div>

</div>

</div>

<mat-dialog-actions align="end">
    <button type="button" mat-button (click)="cancel()">Cancel</button>
    <button type="button" mat-flat-button color="primary" [disabled]="(saveStatus$ | async) === Status.LOADING || hasActiveUpload" (click)="save()">Save</button>
</mat-dialog-actions>
